import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "http/requestConfig";

export default class FiscalPowerService {

    static getAll(options, sCallBack, eCallBack) {
        ApiRoutes.fiscalPowerByCategoryCodeResource.resourceOptions = Object.assign({}, ApiRoutes.fiscalPowerByCategoryCodeResource.resourceOptions, options);
        exeRequest(ApiRoutes.fiscalPowerByCategoryCodeResource, {}, sCallBack, eCallBack)
    }
}